<script>
    import { fade, fly } from 'svelte/transition'

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()
    
    function remove() {
      dispatch('remove', { id })
    }
    
    export let name
    export let id // document ID

</script>

<style>
    .is-complete {
        text-decoration: line-through;
        color: green;
    }

    li {
        display: flex;
        font-size: 1.2em;
        font-weight: bold;
    }

    span {
        margin-right: auto;
    }
</style>


<li in:fly="{{ x: 900, duration: 500 }}" out:fade>

{#if false}
    <span class="is-complete">
        { name }
    </span>
	<button class="is-button" >
		✔️
	</button>
{:else}
    <span>
        { name }
    </span>
	<button class="is-button" >
		❌
	</button>
{/if}

<button class="is-button" on:click={remove}>
    🗑️
</button>

</li>